import EditNoteIcon from "@mui/icons-material/EditNote";
import { Box, IconButton, Link, Typography } from "@mui/joy";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { useNavigate } from "react-router-dom";
import ElevatorNotesDialog from "../Dialogs/ElevatorNotesDialog";
import PortalTableLayout from "../components/PortalTableLayout";
import { Util } from "../Helpers/Util";

export default function OutOfServiceElevators() {
	const [dataset, setDataset] = React.useState([] as Array<any>);
	const [loading, setLoading] = React.useState(true);
	const [notesDialogOpen, setNotesDialogOpen] = React.useState(false);
	const [selectedElevator, setSelectedElevator] = React.useState<any>(null);

	const n = useNavigate();

	React.useEffect(() => getData(), []);

	const getData = () => {
		setLoading(true);
		fetch("Building/GetOutOfServiceElevators", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((x) => {
				setDataset(x);
				setLoading(false);
			});
	};

	const handleOpenNotesDialog = (elevator: any) => {
		setSelectedElevator(elevator);
		setNotesDialogOpen(true);
	};

	const handleCloseNotesDialog = () => {
		setNotesDialogOpen(false);
		setSelectedElevator(null);
	};

	const handleSaveNotes = async (elevatorId: string, notes: string) => {
		try {
			const response = await fetch("Building/SaveElevatorNotes", {
				method: "Post",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					elevators_id: elevatorId,
					notes: notes,
				}),
			});

			if (!response.ok) {
				throw new Error("Failed to save notes");
			}

			getData();
		} catch (error) {
			console.error("Error saving elevator notes:", error);
			throw error;
		}
	};

	return (
		<>
			<PortalTableLayout
				fillHeight={true}
				toolbar={
					<Box
						sx={{
							backgroundColor: "background.surface",
							border: "1px solid",
							borderColor: "divider",
							p: 1.5,
						}}>
						<Typography level="title-lg" sx={{ m: 0 }}>
							Out of Service Elevators
						</Typography>
					</Box>
				}>
				<Table stickyHeader size="small">
					<TableHead>
						<TableRow>
							<TableCell>Building</TableCell>
							<TableCell>Serial Number</TableCell>
							<TableCell>Date Out of Service</TableCell>
							<TableCell>Notes</TableCell>
							<TableCell>Actions</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{loading && (
							<TableRow>
								<TableCell colSpan={5} align="center" sx={{ py: 3 }}>
									<CircularProgress size={32} />
								</TableCell>
							</TableRow>
						)}
						{!loading &&
							dataset.map((x) => (
								<TableRow key={x.elevators_id}>
									<TableCell>
										<Link
											onClick={() => {
												n("/buildingportal/" + x.buildings_id);
											}}>
											{x.name || x.building_name}
										</Link>
									</TableCell>
									<TableCell>{x.serial_number}</TableCell>
									<TableCell>{Util.Formatter(x.date_out_of_service, "D")}</TableCell>
									<TableCell>
										{x.notes ? (
											<span title={x.notes}>{x.notes.length > 50 ? x.notes.substring(0, 50) + "..." : x.notes}</span>
										) : (
											<span style={{ color: "#999" }}>No notes</span>
										)}
									</TableCell>
									<TableCell>
										<IconButton size="sm" onClick={() => handleOpenNotesDialog(x)} title="Edit Notes">
											<EditNoteIcon />
										</IconButton>
									</TableCell>
								</TableRow>
							))}
					</TableBody>
				</Table>
			</PortalTableLayout>

			{selectedElevator && (
				<ElevatorNotesDialog
					open={notesDialogOpen}
					onClose={handleCloseNotesDialog}
					elevatorId={selectedElevator.elevators_id}
					elevatorSerialNumber={selectedElevator.serial_number}
					buildingName={selectedElevator.name || selectedElevator.building_name}
					initialNotes={selectedElevator.notes}
					onSave={handleSaveNotes}
				/>
			)}
		</>
	);
}
